import React from 'react'

//components
// import LogoDark from "../../Assets/Pngs/LogoDark1.png"
// import LogoWhite from "../../Assets/Pngs/LogoWhite1.png"
import ArrowWhite from "../../Assets/Pngs/ArrowWhite.png"

//classes
import classes from "./Loading.css"

const Loading = (props) => {
    let sizeClass = null;
    let size = null;
    let smallArrow = null;
    if(props.small){
        sizeClass = classes.small_config
        size = classes.small_size+' '+classes.small_size_Loading;
        smallArrow = classes.small_size_Arrow;
    }

    return (
        <div className={classes.Loading+' '+size}>
            <div className={classes.UpPart}>
                <div className={classes.UpArrow+' '+classes.button+' '+sizeClass}> <img className={classes.Arrow+' '+classes.UP+' '+smallArrow} src={ArrowWhite} alt='arrow' /></div>
            </div>
            <div className={classes.DownPart}>
                <div className={classes.LeftArrow+' '+classes.button+' '+sizeClass}> <img className={classes.Arrow+' '+classes.LEFT+' '+smallArrow} src={ArrowWhite} alt='arrow' /></div>
                <div className={classes.DownArrow+' '+classes.button+' '+sizeClass}> <img className={classes.Arrow+' '+classes.DOWN+' '+smallArrow} src={ArrowWhite} alt='arrow' /></div>
                <div className={classes.RightArrow+' '+classes.button+' '+sizeClass}> <img className={classes.Arrow+' '+classes.RIGHT+' '+smallArrow} src={ArrowWhite} alt='arrow' /></div>
            </div>
            <div className={classes.EndArea}>
                <div>
                    Please wait...
                </div>
            </div>
        </div>
    )
}

export default Loading;
